// extracted by mini-css-extract-plugin
module.exports = {"inverse":"Row_inverse__11n2g","tight":"Row_tight__3LnqJ","full":"Row_full__r3K5g"};